type Props = {
  name: string
  slug?: string
  className?: string
}

const AuthorLink = ({ name, slug, className }: Props) => {
  if (slug) {
    return (
      <a
        href={`https://edhrec.com/articles/author/${slug}`}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {name}
      </a>
    )
  }
  return <span className={className}>{name}</span>
}

export default AuthorLink
